import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TeamMateState } from "./types";

export const initialState: TeamMateState = {
  showCoachingForm: false,
};

const teamMateSlice = createSlice({
  name: "teamMate",
  initialState,
  reducers: {
    setShowCoachingForm: (state, action: PayloadAction<TeamMateState["showCoachingForm"]>) => {
      state.showCoachingForm = action.payload;
    },
  },
});

export const TeammateActions = teamMateSlice.actions;
export default teamMateSlice;
